exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Century Gothic;src:url(" + require("../fonts/CenturyGothic.eot") + ");src:url(" + require("../fonts/CenturyGothic.eot") + "?#iefix) format(\"embedded-opentype\"),url(" + require("../fonts/CenturyGothic.woff") + ") format(\"woff\"),url(" + require("../fonts/CenturyGothic.ttf") + ") format(\"truetype\");font-weight:400;font-style:normal}.century-gothic{font-family:Century Gothic,sans-serif!important;font-weight:400!important}.force-center{left:50%;-ms-transform:translate(-50%);transform:translate(-50%)}.background-ico-right{background-repeat:no-repeat;background-position:calc(100% - 5px) 50%}.title-section{text-transform:uppercase;color:#fff;line-height:49px}.title-sub-section{font-weight:600!important;font-size:12px!important;text-transform:uppercase!important;color:#2c154d!important;line-height:10px!important;padding-top:10px!important}.List{list-style:none;width:100%;padding:0;margin:0;overflow:hidden}.List li{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/assets/stylesheets/List.scss
// module id = 620
// module chunks = 0